<template>
  <el-container class="form-body">
    <el-main class='form-login-body'>
      <el-form key="d" :model="ruleForm" :rules="rules" ref="ruleForm" @keyup.enter.native="loginClick">
        <!--账号框-->
        <el-form-item prop="phone" class="login-meta">
          <div class="wrap-input">
            <el-input :placeholder="accountPlaceholder" v-model="ruleForm.phone" @input="cleanPassword">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/user.png" alt="" />
                </div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--Web密码框-->
        <el-form-item v-if='isCollapse' prop="password" class="login-meta" :class="supportPhone && supportEmail ? 'login-meta-before-radio' : ''">
          <div class="wrap-input">
            <el-input show-password placeholder="请输入密码" maxlength="20" v-model="ruleForm.password">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--App密码框-->
        <el-form-item v-else prop="password" class="login-meta" :class="supportPhone && supportEmail ? 'login-meta-before-radio' : ''">
          <div class="wrap-input">
            <el-input v-model="ruleForm.password" class="input-icon input-icon-two" size="large" :type="passwordFlag" placeholder="请输入登录密码">
              <template slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </template>
              <template slot="append">
                <div class="input-icon-up" @click="switchPassShow">
                  <img v-if="passwordFlag !== 'password'" src="../../../../assets/look.png" alt="" />
                  <img v-else src="../../../../assets/hidden.png" alt="" />
                </div>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <!--切换手机、邮箱验证码-->
        <el-form-item v-if="supportPhone && supportEmail">
          <div class="code-radio-group">
            <el-radio v-model="currentSendType" label="1" class="code-radio-item" @change="sendTypeChanged">手机验证码
            </el-radio>
            <el-radio v-model="currentSendType" label="2" class="code-radio-item" @change="sendTypeChanged">邮箱验证码
            </el-radio>
          </div>
        </el-form-item>
        <!--验证码-->
        <el-form-item prop="code" class="login-meta login-meta-before-code">
          <div class="wrap-input">
            <el-input :placeholder="`请输入${codeString()}`" maxlength="6" v-model="ruleForm.code">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </div>
              <div slot="append">
                <div class="code-btn" v-show="sendCodeEnable" @click="getCode">获取{{codeString()}}</div>
                <div class="code-count-down" v-show="!sendCodeEnable">{{ codeText }}</div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--提示语-->
        <div class="code-label">
          <div v-if="sendError.length > 0" class="code-label-error">{{ sendError }}</div>
          <div v-else-if="sendResult.length > 0" class="code-label-tips">验证码已发送至{{ sendResult }}</div>
        </div>
        <!--App登录按钮-->
        <el-form-item v-if='!isCollapse' class="form-bottom">
          <div class="bottom-pwd">
            <el-checkbox class="remember-pass" v-model="isChecked" @change="checkPasswordChange">记住密码</el-checkbox>
            <div class="pass-text" @click="gotoForgetPwd()">忘记密码</div>
          </div>
          <el-button size="large" type="primary" class="login-button" @click.stop.prevent="loginClick">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <!--Web登录按钮-->
    <el-footer v-if='isCollapse' class='form-login-footer' style="height: 78px !important;">
      <div class="bottom-pwd">
        <el-checkbox class="remember-pass" v-model="isChecked" @change="checkPasswordChange">记住密码</el-checkbox>
        <div class="pass-text" @click="gotoForgetPwd()">忘记密码</div>
      </div>
      <el-button type="primary" @click="loginClick" class="login-btn">
        登录
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import 'vant/lib/index.css';
import { verifyWebCode } from '@/api/api.p'
import * as LoginType from "@/pages/m/views/login/loginType";
import { decrypt, encrypt, getStorage, removeStorage, setStorage } from '@/libs/util'

export default {
  name: 'login-by-union',
  props: {
    isCollapse: {
      type: Boolean,
      value: false,
    },
    accountPlaceholder: {
      type: String,
      value: '',
    },
    supportTypeList: {
      type: Array,
      value: [],
    }
  },
  data () {
    const validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.accountPlaceholder));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '' && this.sendError.length === 0) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      passwordFlag: 'password',
      supportPhone: false,
      supportEmail: false,
      currentSendType: null,
      codeText: '',
      sendCodeEnable: true,
      sendResult: "",
      sendError: "",
      timer: null,
      isChecked: false,
      ruleForm: {
        phone: '',
        code: '',
        password: '',
      },
      rules: {
        phone: [
          { validator: validateAccount, trigger: 'blur' },
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
    }
  },
  watch: {
    supportTypeList () {
      this.supportTypeListChanged();
    }
  },
  mounted () {
    this.supportTypeListChanged();
    let account = getStorage('login_account');
    let pass = getStorage('login_password');
    console.log('account = ', account);
    console.log('pass = ', pass);
    if (account != null && pass != null) {
      this.ruleForm.password = decrypt(pass);
      this.ruleForm.phone = decrypt(account);
      this.isChecked = true;
    }
  },
  methods: {
    supportTypeListChanged () {
      this.supportPhone = this.supportTypeList.includes(LoginType.LOGIN_TYPE_UNION_PHONE);
      this.supportEmail = this.supportTypeList.includes(LoginType.LOGIN_TYPE_UNION_EMAIL);
      if (this.supportPhone) {
        this.currentSendType = '1';
      } else if (this.supportEmail) {
        this.currentSendType = '2';
      } else {
        this.currentSendType = null;
      }
    },
    checkPasswordChange (value) {
      if (value) {
        setStorage('login_password', encrypt(this.ruleForm.password))
        setStorage('login_account', encrypt(this.ruleForm.phone))
      } else {
        removeStorage('login_password')
        removeStorage('login_account')
      }
    },
    cleanPassword () {
      removeStorage('login_password');
      removeStorage('login_account');
      this.ruleForm.password = '';
    },
    switchPassShow () {
      this.passwordFlag = this.passwordFlag === 'password' ? 'text' : 'password'
    },
    gotoForgetPwd () {
      this.$emit('gotoForgetPwd');
    },
    sendTypeChanged (e) {
      this.sendError = "";
      this.sendResult = "";
    },
    codeString () {
      return this.currentSendType === '2' ? '邮箱验证码' : '手机验证码';
    },
    async getCode () {
      if (this.ruleForm.phone === '') {
        this.$toast(`请先输入${this.accountPlaceholder}`);
        return;
      }
      if (this.currentSendType === null) {
        this.$toast('登录方式不正确，请确认。');
        return;
      }
      if (!this.sendCodeEnable) {
        return;
      }
      let param = {
        loginName: this.ruleForm.phone,
        sendType: this.currentSendType,
      }
      this.sendResult = "";
      this.sendError = "";
      this.sendCodeEnable = false;
      this.codeText = `获取${this.codeString()}`;
      const res = await verifyWebCode(param, {
        headers: {
          'kywebInfo': 'channel/unify,osName/web,appName/%e5%bf%ab%e5%ba%94%e5%ae%a2%e7%bd%91%e7%ab%99,appVersion/111,appBuildNumber/xxx,appId/xxx'
        }
      });
      if (res && res.meta) {
        if (res.meta.code === 0) {
          if (res.data && res.data.length > 0) {
            this.sendResult = res.data;
            this.countDown(59)
          } else {
            this.sendCodeEnable = true;
            this.$toast('发送失败');
          }
        } else {
          this.sendCodeEnable = true;
          this.sendError = res.meta.message;
        }
      } else {
        this.sendCodeEnable = true;
        this.$toast('发送失败');
      }
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.sendCodeEnable = true;
        return
      } else {
        this.sendCodeEnable = false;
        this.codeText = '重新获取' + time + '秒';
        time--;
      }
      this.timer = setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    /*登录接口*/
    async loginClick () {
      console.log('loginClick');
      if (this.currentSendType === null) {
        this.$toast('登录方式不正确，请确认。');
        return;
      }
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          await this.didLogin();
        } else {
          return false;
        }
      });
    },
    async didLogin () {
      this.checkPasswordChange(this.isChecked);
      let param = {
        "agree": "1",//
        //密码ζ验证码
        "loginCode": (this.ruleForm.password + 'ζ' + this.ruleForm.code),
        "loginName": this.ruleForm.phone,
        "loginType": this.currentSendType === '1' ? '51' : '52',
      }
      this.$emit('login', param);
    },
  }
}
</script>